import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiPaperStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            borderRadius: variables.borderRadius.primary,
            maxWidth: '1200px',
            '&.WalletUploadFileInput': {
                borderColor: variables.colors.other.inputs.default,
                borderWidth: '1px',
                borderRadius: variables.borderRadius.primary,
                transition: 'all 0.15s',
            },
            '&.WalletUploadFileInput:hover': {
                borderColor: variables.colors.other.inputs.hover,
            },
            '&.WalletUploadFileInput.Mui-error': {
                borderColor: variables.colors.error.main,
            },
        },
    },
});

export default createMuiPaperStyles;
